<template>
    <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap h-100 flex-column text-center">
        <div>
            <small v-if="event.isOnline">
                <font-awesome-icon icon="globe" />
                <strong>
                    <EventEntryOnlineInfo
                        :link="event.onlineLink"
                        :application="event.onlineApplication"
                        :appointment="isAppointment"
                        plain-text />
                </strong>
            </small>
            <small v-if="event.location && event.location.name">
                <font-awesome-icon
                    icon="map-marker-alt"
                    class="mr-1" />
                <strong> {{ event.location.name }}</strong>
                <span v-if="event.location.address && event.location.address.city">,
                    {{ event.location.address.city }}
                </span><span
                    v-if="event.location.address && event.location.address.district
                        && event.location.address.district !== event.location.address.city">
                    ({{ event.location.address.district }})
                </span>
                <el-tooltip v-if="event.location.lowBarrier && event.location.lowBarrier === 1">
                    <template #content>{{ $t('iFrame.lowBarrier') }}</template>
                    <font-awesome-icon icon="wheelchair" />
                </el-tooltip>
            </small>
        </div>
        <div
            v-if="event.alternativeOrganizer && event.alternativeOrganizer.image"
            style="max-width: 80px">
            <img
                :src="event.alternativeOrganizer.image"
                :alt="event.alternativeOrganizer.name"
                class="img-fit">
        </div>
        <small
            v-else-if="event.alternativeOrganizer"
            class="text-center">
            {{ event.alternativeOrganizer.name }}
        </small>
        <div
            v-else-if="event.organizer && event.organizer.image"
            style="max-width: 80px">
            <img
                :src="event.organizer.image"
                :alt="event.organizer.name"
                class="img-fit">
        </div>
        <small v-else-if="event.organizer">
            {{ event.organizer.name }}
        </small>
    </div>
</template>

<script>
import EventEntryOnlineInfo from './EventEntryOnlineInfo'

export default {
    name: "EventEntryLocationAndOrganizerInfo",
    components: {EventEntryOnlineInfo},
    inject: ['iFrameType'],
    props: {
        event: {
            type: Object,
            required: true
        },
        smaller: {
            type: Boolean
        }
    },
    computed: {
        isAppointment() {
            return this.iFrameType() === 'appointments'
        }
    }
}
</script>

<style lang="scss" scoped>
.img-fit {
    width: 100%;
    object-fit: cover;
}
</style>
